import React from "react";
import SettingContainer from "../containers/SettingContainer";

export default function Setting() {
  return <SettingContainer />;
}
